import React, { useEffect, useState } from 'react';
export const COOKIE_CONSENT_KEY = 'viridia_cookie_consent';
export type ConsentValue = 'accepted' | 'declined';
export function getStoredConsent(): ConsentValue | null {
  try {
    const v = window.localStorage.getItem(COOKIE_CONSENT_KEY);
    return v === 'accepted' || v === 'declined' ? v : null;
  } catch {
    return null;
  }
}

// Fires a real browser event so App.tsx's tracking-script effect (which only
// runs once on mount) can react immediately if the visitor decides mid-session,
// instead of requiring a reload to take effect.
function setStoredConsent(value: ConsentValue) {
  try {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, value);
  } catch {
    // localStorage unavailable (private browsing, etc.) -- fail open to
    // "accepted" for this session only, nothing to persist.
  }
  window.dispatchEvent(new CustomEvent('viridia-consent-change', {
    detail: value
  }));
}
export function CookieConsent() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(getStoredConsent() === null);
  }, []);
  if (!visible) return null;
  const choose = (value: ConsentValue) => {
    setStoredConsent(value);
    setVisible(false);
  };
  return <div role="region" aria-label="Cookie consent" className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/10 bg-viridia-black/95 backdrop-blur-sm" data-id="element-188" data-mp="26eq2777obunx">
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6 sm:px-6" data-id="element-189" data-mp="1whbubvztge78">
        <p className="text-sm leading-relaxed text-viridia-light/80" data-id="element-190" data-mp="21elfv0k345ps">
          We use cookies for analytics and to show you relevant ads (Meta,
          Google). See our{' '}
          <a href="/privacy" className="underline decoration-viridia/60 underline-offset-2 hover:text-viridia" data-id="element-191" data-mp="1sgjkp1n187af">
            Privacy Policy
          </a>
          .
        </p>
        <div className="flex shrink-0 gap-3" data-id="element-192" data-mp="3muaovlmldyyh">
          <button type="button" onClick={() => choose('declined')} className="rounded-md border border-white/15 px-4 py-2 text-sm font-medium text-viridia-light/70 transition-colors hover:border-white/30 hover:text-viridia-light" data-id="element-193" data-mp="3mry9ng87y2p4">
            Decline
          </button>
          <button type="button" onClick={() => choose('accepted')} className="rounded-md bg-viridia px-4 py-2 text-sm font-semibold text-viridia-black transition-colors hover:bg-viridia-dark hover:text-white" data-id="element-194" data-mp="36fl3avaalz7j">
            Accept
          </button>
        </div>
      </div>
    </div>;
}